import { EVENT_DEDUP_WINDOW_MS } from './constants';

export function createEventDeduper(windowMs = EVENT_DEDUP_WINDOW_MS) {
  const last = new Map();

  function dedupeSecurityEvent(type, timeWindowMs = windowMs) {
    const now = Date.now();
    const prev = last.get(type) || 0;
    if (now - prev < timeWindowMs) return true;
    last.set(type, now);
    return false;
  }

  function mark(type) {
    last.set(type, Date.now());
  }

  return { dedupeSecurityEvent, mark };
}
